import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Conditionally load OM Design System if available
(async () => {
  try {
    // eslint-disable-next-line import/no-unresolved
    await import('./vendor/@om-design-system/web-components/dist/om-design-system-web/om-design-system-web.css');
    // eslint-disable-next-line import/no-unresolved
    const { defineCustomElements } = require('./vendor/@om-design-system/web-components/loader');
    defineCustomElements(window);
  } catch (e) {
    // Design system not available - app will work without it
    console.log('OM Design System not loaded');
  }
})();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);